import "./index.css";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar">
      <Link to="/" className="navbar__logo">
        Habitime
      </Link>

      <a href="/download" className="navbar__cta">
        Download
      </a>
    </nav>
  );
};

export default Navbar;
